import React, { useEffect, useState } from 'react';
import QuestionHeader from '../shared/questionHeader/QuestionHeader';
import QuestionAnswers from './components/questionAnswers/QuestionAnswers';
import styles from './textQuestion.css';
import { getScreenType } from '../../../../../../utils/func';

/**
 *
 * @type {React.NamedExoticComponent<{readonly statisticsPopup?: *, readonly setEventSound?: *, readonly handleAnswerSelection?: *, readonly contentColor?: *, readonly question?: *, readonly statistics?: *}>}
 */
const TextQuestion = React.memo(( { question, statistics, statisticsPopup, handleAnswerSelection, contentColor, setEventSound } ) => {

    const [ img, setImg ] = useState( '' );

    const getImageForScreenType = () => {
        const { image, image_desktop } = question;
        const screenType = getScreenType();

        switch ( screenType ) {
            case 'Desktop': {
                return image_desktop;
            }
            case 'Mobile': {
                return image;
            }
            default: {
                return image_desktop;
            }
        }
    };

    const updateImage = () => {
        const image = getImageForScreenType();
        setImg( { background: `url(${ image && image.url })` } );
    };

    useEffect( () => {
        updateImage();
    }, [ question ] );

    const { image_position } = question.localization;
    const isCover = image_position === 'cover';

    return (
        <div className={ styles.wrapper }
             style={ statisticsPopup ? { pointerEvents: 'none' } : { filter: 'none' } }>
            { isCover && ( typeof img.background !== 'undefined' ) &&
            <div className={ styles.coverWrap }
                 style={ isCover ? { backgroundImage: `${ img.background }` } : { background: 'none' } }/>
            }
            <QuestionHeader
                question={ question }
                statistics={ statistics }
                statisticsPopup={ statisticsPopup }
                contentColor={ contentColor }
                setEventSound={ setEventSound }
            />
            <QuestionAnswers
                statistics={ statistics }
                question={ question }
                answers={ question.localization.editor_mode_answers }
                handleAnswerSelection={ handleAnswerSelection }
                contentColor={ contentColor }
                setEventSound={ setEventSound }
            />
        </div>
    );
});

export default TextQuestion;
